import axiosClient from "./axiosClient";

const endpoint = "/autoreplybuilder/commerce-order-policy-profiles";

export async function listAutoReplyCommercePolicyProfiles(includeInactive = true) {
  const response = await axiosClient.get(endpoint, {
    params: { includeInactive },
    __silentGenericToast: true,
  });
  const value = response?.data?.payload ?? response?.data?.data ?? response?.data ?? [];
  return Array.isArray(value) ? value : [];
}
